export function shouldResetFlightOptionId(oldModel: any, newModel: any): boolean {
  if (!oldModel) return true;
  const fieldsToCompare = ['arrivalData', 'departureData', 'travelTiming', 'seatsNeeded'];
  return fieldsToCompare.some(field => JSON.stringify(oldModel?.[field]) !== JSON.stringify(newModel?.[field]));
}
